import React from "react";
import { HeroSlides } from "@/admin/HeroSlides";
import { miniInput, SecondsInput } from "@/admin/SortableList";

const PAGES: [string, string][] = [["engagement-rings", "Engagement"], ["wedding-anniversary", "Wedding & Anniversary"], ["fine-jewellery", "Fine Jewelry"], ["mens", "Men's"]];

// Rotating banner images for the main menu collection pages.
export function MenuHeroesEditor({ value, onChange }: { value: any; onChange: (v: any) => void }) {
  const all = value || {};
  const up = (slug: string, patch: any) => onChange({ ...all, [slug]: { rotation: "random", interval: 3, slides: [], ...all[slug], ...patch } });
  return (
    <div className="space-y-8" data-testid="menu-heroes-editor">
      <p className="text-xs text-neutral-500">Each main menu page shows these images as a rotating banner with the text inside the image. Untick every slide (or remove them) to go back to the plain page title.</p>
      {PAGES.map(([slug, label]) => {
        const h = all[slug] || {};
        return (
          <section key={slug} className="border border-neutral-200 p-4" data-testid={`menu-hero-${slug}`}>
            <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
              <h3 className="font-display text-lg">{label} <a href={`/collections/${slug}`} target="_blank" rel="noreferrer" className="text-xs underline ml-2">View page</a></h3>
              <div className="flex flex-wrap gap-3 text-xs text-neutral-600">
                <label>When no image is scheduled{" "}
                  <select value={h.rotation || "random"} onChange={(e) => up(slug, { rotation: e.target.value })} className={miniInput} data-testid={`menu-hero-${slug}-rotation`}>
                    <option value="random">Random on every visit</option><option value="season">Current season first, then random</option>
                  </select>
                </label>
                <label>Seconds per image{" "}
                  <SecondsInput value={h.interval} def={3} min={2} max={30} onChange={(v) => up(slug, { interval: v })} testId={`menu-hero-${slug}-interval`} />
                </label>
              </div>
            </div>
            <HeroSlides value={h.slides || []} onChange={(v: any) => up(slug, { slides: v })} previewBase={`/collections/${slug}`} where={`the ${label} page`} />
          </section>
        );
      })}
    </div>
  );
}
